module.exports = __webpack_public_path__ + "c3be09fd46c5e113b7aba06330cb5d8a.svg";